module.exports = __webpack_public_path__ + "img/1spade-09.75ef130c.svg";